export default function GardenDefenseIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true" fill="none" strokeLinecap="round">
      <rect x="2" y="40" width="60" height="22" rx="4" fill="#5db53d" />
      <path d="M2 50h60" stroke="#6cc24a" strokeWidth="6" />
      <path d="M18 58c4-10 2-18-2-26" stroke="#3f8f2a" strokeWidth="4" />
      <ellipse cx="12" cy="48" rx="3" ry="8" fill="#5cbf3a" transform="rotate(-20 12 48)" />
      <ellipse cx="31" cy="18" rx="8" ry="4.5" fill="#c43a76" transform="rotate(-30 31 18)" />
      <ellipse cx="31" cy="30" rx="8" ry="4.5" fill="#c43a76" transform="rotate(30 31 30)" />
      <ellipse cx="18" cy="24" rx="13" ry="11" fill="#ff6fa8" />
      <circle cx="31" cy="24" r="4" fill="#4a1236" />
      <circle cx="14" cy="22" r="3" fill="#fff" />
      <circle cx="21" cy="22" r="3" fill="#fff" />
      <circle cx="15" cy="22.5" r="1.5" fill="#1b1b1b" />
      <circle cx="22" cy="22.5" r="1.5" fill="#1b1b1b" />
      <ellipse cx="42" cy="24" rx="3.5" ry="2.5" fill="#8d6e3a" />
      <path d="M50 44l6-30 6 30z" fill="#8e24aa" />
      <circle cx="56" cy="47" r="6" fill="#ffcc9e" />
      <path d="M50 48q6 12 12 0" fill="#fafafa" />
      <path d="M10 3c3 4 5 7 5 9.5a5 5 0 0 1-10 0C5 10 7 7 10 3z" fill="#6fd0ff" stroke="#1e7fd0" strokeWidth="1.2" />
    </svg>
  );
}
